import { defineStore } from 'pinia';

export const useAuthStore = defineStore("auth", {
    state: () => ({
        token: localStorage.getItem('token') || "",
        user: localStorage.getItem('user') || "{}",
    }),
    actions: {
        setToken(token) {
            this.token = token;
            localStorage.setItem('token', token);
        },
        setUser(userData) {
            this.user = userData;
            localStorage.setItem('user', userData);
        },
        logout() {
            this.token = '';
            this.user = null;
            localStorage.removeItem('token');
            localStorage.removeItem('user');
        },
    },
});